import NP from "./NP";
import Delegate from "./Delegate";

export interface IErrorResponse {
	clazz?: string;
	message: string
	status?: number;
	detail?: string;
	safeHTML?: string;
	IsUserException?: boolean;
	skipShow?: boolean;
}


export module ServerAPI {

	export let _countActiveRequests = 0;
	export let _countActiveRequestsNW = 0;
	export let idTimeStatus: any = null;

	export let EvEndRequest: Delegate = new Delegate();
	export let EvStartRequest: Delegate = new Delegate();
	export let EvError: Delegate = new Delegate();
	export let EvSessionClosed: Delegate = new Delegate();
	export let EvAppUpdated: Delegate = new Delegate();

	export function getCountAR()
	{
		return _countActiveRequests;
	}

	export function hasActiveRequest()
	{
		return _countActiveRequests > 0;
	}

	function _incActive(showWaiter: boolean)
	{
		if (showWaiter !== false)
			ServerAPI._countActiveRequests++;
		else
			ServerAPI._countActiveRequestsNW++;
	}

	function _decActive(showWaiter: boolean)
	{
		if (showWaiter !== false)
			ServerAPI._countActiveRequests--;
		else
			ServerAPI._countActiveRequestsNW--;
	}

	function sleep(timeout: number)
	{
		return new Promise((resolve) =>
		{
			setTimeout(() =>
			{
				resolve(null)
			}, timeout)
		})
	}

	function retry(url: string, body: object = null, method: string = 'GET')
	{
		//API_ERROR.connectionLostCallback();
		return new Promise(async (resolve, reject) =>
		{
			for (let i = 0; i < 666; i++)
			{
				await sleep(5000);
				try
				{
					let response = await callUiApi(url, body, method, false);
					//API_ERROR.connectionRestoreCallback();
					resolve(response);
					return;
				} catch (e)
				{
					//всё ещё недоступно
				}
			}
			reject();  //сдаёмся
		})
	}

	export function post<T>(url: string, body: object = null, showWaiter = true): Promise<T>
	{
		return callUiApi<T>(url, body, 'POST', false, showWaiter)
	}

	export function get<T>(url: string, showWaiter = true): Promise<T>
	{
		return callUiApi<T>(url, null, 'GET', true, showWaiter)
	}

	export function put<T>(url: string, body: object = null): Promise<T>
	{
		return callUiApi<T>(url, body, 'PUT')
	}

	export function delet<T>(url: string, body: object = null): Promise<T>
	{
		return callUiApi<T>(url, body, 'DELETE')
	}

	export function callUiApi<T>(url: string,
										  body: object = null,
										  method: string = 'GET',
										  doRetry = true,
										  showWaiter = true): Promise<T>
	{
		_incActive(showWaiter);
		ServerAPI.EvStartRequest.fire(this, {
			Show: showWaiter
		});

		return new Promise((resolve, reject) =>
		{
			fetch(window.location.origin + '/ui-api' + url, {
				method: method,
				cache: 'no-cache',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json;charset=utf-8'
				},
				body: method == 'GET' ? null : (body != null ? JSON.stringify(body) : "{}")
			}).then(function (response)
			{
				_decActive(showWaiter);
				ServerAPI.EvEndRequest.fire(this);

				if (response.status == 200 && response.redirected && response.url.indexOf("login") > -1)
				{
					window.location.reload();
					return;
				}

				if (response.status == 404 || response.status == 502)		//возможно приложение деплоится ещё или лежит
				{
					if (doRetry)
						retry(url, body, method).then((r: any) => resolve(r))
					else
						reject(response)
					return;
				}

				if (response.status >= 300)
				{
					response.text().then((errorResponse: string) =>
					{
						reject();
						ServerAPI.EvError.fire(this, {
							message: errorResponse,
							Status: response.status || 0
						});
					});

					return Promise.reject(new Error(response.statusText));
				}
				return Promise.resolve(response);
			}).then((response: any) => response.headers.get('Content-Length') == "0" ? response.text() : response.json())
				 .then((response: any) =>
				 {
					 return resolve(response);
				 })
				 .catch((response) =>
				 {
					 if (response.message.indexOf('Unexpected end of JSON input') > -1)
						 resolve(null);
					 else if (response.message.toLowerCase().indexOf('failed to fetch') > -1)
					 {
						 if (doRetry)
							 retry(url, body, method).then((r: any) => resolve(r))
						 else
							 reject(response)
					 }
					 else
						 reject(response.message);
				 });
		});
	}

}

NP.ServerAPI = ServerAPI;
